import React, { useEffect, useState, useCallback, useMemo } from "react";
import classNames from "classnames";
import { useMediaQuery } from "react-responsive";
import { Link, useLocation } from "react-router-dom";

import Navigation from "../navigation/Navigation";
import LogoRus from "../../assets/svg/LogoRus";
import { Modal, MobileMenu, CitySelection } from "../";
import { useBlockScroll } from "../../hooks";

import BurgerIco from "./BurgerIco";
import styles from "./Header.module.scss";

const Header = ({ contact, setCity }) => {
  const isDesktop = useMediaQuery({ query: "(min-width: 980px)" });
  const isMobile = !isDesktop;

  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isCityListOpen, setIsCityListOpen] = useState(false);
  const [isActiveSubmenu, setActiveSubmenu] = useState(false);

  const [blockScroll, allowScroll] = useBlockScroll();

  const { pathname } = useLocation();

  const [position, setPosition] = useState(window.pageYOffset);
  const [isTopPosition, setIsTopPosition] = useState(true);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const moving = window.pageYOffset;

      setVisible(position <= 0 || position >= moving);

      setPosition(moving);
      setIsTopPosition(moving === 0);

      if (isActiveSubmenu) setActiveSubmenu(false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  const openMenu = () => {
    setMobileMenuOpen(true);

    blockScroll();
  };

  const closeMenu = useCallback(() => {
    setMobileMenuOpen(false);

    allowScroll();
  }, [allowScroll]);

  const openCityList = () => {
    setIsCityListOpen(true);

    blockScroll();
  };

  const closeCityList = () => {
    setIsCityListOpen(false);

    if (!isMobileMenuOpen) {
      allowScroll();
    }
  };

  useEffect(() => {
    closeMenu();
  }, [pathname]);

  const isInvertedColor = useMemo(() => {
    return (
      pathname.includes("/projects/") &&
      pathname.split("/projects/")[1] &&
      pathname.split("/projects/")[1].length > 0
    );
  }, [pathname]);

  return (
    <div
      className={classNames(
        styles.Root,
        !isTopPosition && styles.StuckPosition,
        isInvertedColor && styles.InvertedColor,
        isTopPosition && styles.TopPosition,
        visible || styles.headerFade,
      )}
    >
      <div className={"wrap holder no-pdn-top"}>
        <header className={classNames(styles.header)}>
          {isCityListOpen && (
            <Modal close={closeCityList} className={styles.CitySelection}>
              <CitySelection close={closeCityList} setCity={setCity} />
            </Modal>
          )}

          <div className={styles.headerLogo}>
            <Link to="/">
              <LogoRus
                className={classNames(
                  styles.Logo,
                  isMobileMenuOpen && styles.ModalLogo,
                )}
              />
            </Link>
          </div>

          {isDesktop && (
            <Navigation
              className={styles.Navigation}
              isOpenedMenu={isActiveSubmenu}
              toggleMenu={setActiveSubmenu}
            />
          )}

          {isDesktop && (
            <div className={styles.headerContact}>
              {/* {contact && contact.city && (
                <span
                  onClick={openCityList}
                  className={styles.headerContactCity}
                >
                  {contact.city}
                </span>
              )} */}

              {contact && contact.phone && (
                <a
                  href={`tel:${contact.phone}`}
                  target="_self"
                  className={styles.headerContactPhone}
                >
                  {contact.phone}
                </a>
              )}
            </div>
          )}

          {isMobile && (
            <BurgerIco
              className={isMobileMenuOpen && styles.ModalBurger}
              isOpen={isMobileMenuOpen}
              open={openMenu}
              close={closeMenu}
            />
          )}

          {isMobileMenuOpen && (
            <MobileMenu className={styles.MobileMenu}>
              <Navigation
                className={styles.MobileNavigation}
                isOpenedMenu={isActiveSubmenu}
                toggleMenu={setActiveSubmenu}
                allowScroll={allowScroll}
              />

              <div className={styles.Divider}></div>

              <div className={styles.headerContact}>
                {/* {contact && contact.city && (
                  <span
                    onClick={openCityList}
                    className={styles.headerContactCity}
                  >
                    {contact.city}
                  </span>
                )} */}

                {contact && contact.phone && (
                  <a
                    href={`tel:${contact.phone}`}
                    target="_self"
                    className={styles.headerContactPhone}
                  >
                    {contact.phone}
                  </a>
                )}
              </div>
            </MobileMenu>
          )}
        </header>
      </div>
    </div>
  );
};

export default Header;
